import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const studentService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching student list", error);
            throw error;
        }
    },

    async findById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/student/findById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById student", error);
            throw error;
        }
    },

    async save(student: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student/save`,
                student
            );
            return response.data;
        } catch (error) {
            console.error("Error save student", error);
            throw error;
        }
    },

    async deleteById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/student/deleteById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById student", error);
            throw error;
        }
    },

    async uploadStudentsCsv(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student/upload-students-csv`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error save student", error);
            throw error;
        }
    },

    async processStudentsCsv(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student/process-students-csv`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error delete students", error);
            throw error;
        }
    },
}

export default studentService;